import React from 'react';
import { useTranslation } from 'react-i18next';

import './css/WhatsCoveredLinkUpdate.css';

const WhatsCoveredLinkUpdate = ({
  className = '',
  icon = null,
  id = 'whatsCoveredLink',
  isHeader,
  onClick = () => { },
  text = '',
}) => {
  const { t } = useTranslation('changeCoverage');

  return (
    <button
      className={`Powerup-see-whats-covered-link-main-container ${className}`}
      id={id}
      onClick={onClick}
      type="button"
    >
      {icon && (
        <img
          alt=""
          className="Powerup-card-plan-info-image"
          src={icon}
        />
      )}

      <p
        className={'Powerup-see-whats-covered-link '
          + `${isHeader ? 'No-mobile' : ''}`}
      >
        {text || t('whatsCovered')}
      </p>
    </button>
  );
};

export { WhatsCoveredLinkUpdate };
